module.exports = fox._r("images/root-sprite.png", __webpack_public_path__ + "_/_/_/root/images/root-sprite.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/root-sprite.png
// module id = 405
// module chunks = 4